//
// 連携先サービス作成画面
//
document.addEventListener("DOMContentLoaded", (_event) => {
  const pages = document.getElementsByClassName("integration-form");
  if (pages.length == 0) return;

  const selectBox = document.querySelector(".select");

  selectBox.addEventListener("change", (event) => {
    const redirectUrl = event.target.value;

    if (redirectUrl !== "") {
      window.location = redirectUrl;
    }
  });
});

//
// Googleスプレッドシート設定画面
//
document.addEventListener("DOMContentLoaded", (_event) => {
  const spreadSheetForm = document.querySelector(
    ".google-spread-sheet-integration-form[data-accessibility-api]"
  );
  if (!spreadSheetForm) return;

  const apiUrl = spreadSheetForm.dataset.accessibilityApi;
  const clientEmail = spreadSheetForm.dataset.clientEmail;

  if (!(apiUrl && clientEmail)) return;

  const appendHeaderCancel = document.querySelector(
    "[data-append-header-cancel]"
  );

  const checkAccessibility = (sheetUrl, callback) => {
    fetch(apiUrl + "?" + new URLSearchParams({ sheet_url: sheetUrl }))
      .then((response) => response.json())
      .then((data) => {
        const { skip, access, edit } = data;
        callback(skip, access, edit);
      });
  };

  spreadSheetForm.addEventListener("submit", (event) => {
    event.preventDefault();
    event.stopPropagation();

    const fd = new FormData(event.target);
    const sheetUrl = fd.get("google_spread_sheet_integration[sheet_url]");

    checkAccessibility(sheetUrl, (skip, access, edit) => {
      if (skip) {
        event.target.submit();
        return;
      }

      if (!access) {
        if (
          !confirm(
            `「${clientEmail}」のアカウントが追加されていません。このまま保存しますか?`
          )
        ) {
          return;
        }
        if (appendHeaderCancel) appendHeaderCancel.checked = true;
      } else if (!edit) {
        if (
          !confirm(
            `「${clientEmail}」のアカウントを編集者に設定する必要があります。このまま保存しますか?`
          )
        ) {
          return;
        }
        if (appendHeaderCancel) appendHeaderCancel.checked = true;
      }
      event.target.submit();
    });

    return false;
  });
});
